<template>
  <!-- The z-index value is purposefully set to a value that is way higher than our highest (currently at 2000) -->
  <v-dialog
    data-locator="maintenance-dialog-container"
    content-class="bg-white pa-8"
    :content-props="{ 'data-test': 'maintenance-mode-dialog' }"
    :model-value="true"
    fullscreen
    :persistent="true"
    transition="fade-transition"
    :z-index="2100"
  >
    <v-img
      src="@/assets/img/closd_logo.svg"
      width="120"
      transition="scale-transition"
      alt="Logo"
    />
    <div
      class="d-flex flex-column align-center justify-center fill-height pa-6 text-center"
    >
      <v-img
        class="mb-8"
        src="@/assets/img/maintenance/maintenance-icon.svg"
        width="112"
        max-height="112"
      />
      <h3
        class="maintenance-title mb-3 text-grey-900"
        data-locator="maintenance-dialog-title"
        data-test="title"
      >
        {{ $t('maintenance.Maintenance.title') }}
      </h3>
      <p
        v-if="!retry"
        class="text-body-1 mb-0 text-grey-800"
        data-locator="maintenance-dialog-text"
        data-test="body">
        {{ $t('maintenance.Maintenance.body') }}
      </p>
      <p
        v-else
        class="text-body-1 mb-0 text-grey-800"
        data-locator="maintenance-dialog-text"
        data-test="body-with-date"
      >
        {{ $t('maintenance.Maintenance.bodyDate', { date: retry }) }}
      </p>
      <p class="text-body-1 text-grey-800">
        {{ $t('maintenance.Maintenance.endHint') }}
      </p>
    </div>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

import { ISOToShortDate } from '@/common/utils/dates'
import maintenanceService from '@/services/maintenance.service'
import { SET_MAINTENANCE_MODE_ENABLED, SET_RETRY_AT } from '@/store/modules/maintenance/mutation_types'

export default {
  name: 'Maintenance',
  data () {
    return {
      getStatusTimeout: null,
    }
  },
  computed: {
    ...mapState('maintenance', ['retryAt']),
    retry () {
      if (this.retryAt) {
        return ISOToShortDate(this.retryAt)
      }
      return null
    },
  },
  created () {
    this.getStatus()
  },
  beforeUnmount () {
    clearTimeout(this.getStatusTimeout)
  },
  methods: {
    async getStatus () {
      try {
        await maintenanceService.getSiteUp()
        this.$store.commit(`maintenance/${SET_RETRY_AT}`, null)
        this.$store.commit(`maintenance/${SET_MAINTENANCE_MODE_ENABLED}`, false)
      } catch (error) {
        if (error.response?.status === 503) {
          this.getStatusTimeout = setTimeout(() => { this.getStatus() }, 1000 * 60)
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.maintenance-title {
  font-size: 24px;
}
</style>
